import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1",
  {
    variants: {
      variant: {
        default:     "border-transparent bg-ink-950 text-white",
        secondary:   "border-transparent bg-ink-100 text-ink-950",
        accent:      "border-transparent bg-citrus-500/30 text-ink-950",
        coral:       "border-transparent bg-coral-500/15 text-coral-600",
        success:     "border-transparent bg-[#00D68F]/15 text-[#008A5B]",
        destructive: "border-transparent bg-danger/15 text-danger",
        outline:     "border-ink-200 text-ink-950 bg-white",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
